import { useEffect, useRef, useState } from 'react'
import MapFallback from './mapFallback'
import { AMAP_KEY, AMAP_SECURITY_CODE, isAmapConfigured, HQ_LOCATION } from '@/config/amap'

const SDK_URL = 'https://webapi.amap.com/maps?v=2.0&plugin=AMap.Scale'

let loaderPromise = null

/** 动态注入高德 JS API，避免首屏加载第三方脚本 */
function loadAmap() {
  if (loaderPromise) return loaderPromise

  if (AMAP_SECURITY_CODE) {
    // 安全密钥：高德要求先设置再加载 SDK
    window._AMapSecurityConfig = { securityJsCode: AMAP_SECURITY_CODE }
  }

  loaderPromise = new Promise((resolve, reject) => {
    if (window.AMap) return resolve(window.AMap)

    const script = document.createElement('script')
    script.src = `${SDK_URL}&key=${encodeURIComponent(AMAP_KEY)}&plugin=AMap.Scale`
    script.async = true
    script.onload = () => (window.AMap ? resolve(window.AMap) : reject(new Error('AMap 未就绪')))
    script.onerror = () => reject(new Error('高德地图脚本加载失败'))
    document.head.appendChild(script)
  })

  return loaderPromise
}

function AmapView() {
  const holder = useRef(null)
  const mapRef = useRef(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (!isAmapConfigured) return undefined
    let disposed = false

    loadAmap()
      .then((AMap) => {
        if (disposed || !holder.current) return

        const map = new AMap.Map(holder.current, {
          zoom: 12,
          center: [HQ_LOCATION.lng, HQ_LOCATION.lat],
          viewMode: '2D',
          mapStyle: 'amap://styles/whitesmoke',
        })

        const marker = new AMap.Marker({
          position: [HQ_LOCATION.lng, HQ_LOCATION.lat],
          title: '丰源电力科技（涿州）有限公司',
        })
        map.add(marker)
        map.add(new AMap.Scale())

        // 使用公司名称+地址作为标注内容，不臆造其他信息
        const infoWindow = new AMap.InfoWindow({
          isCustom: false,
          offset: new AMap.Pixel(0, -28),
          content: '<div style="padding:4px 8px;font-size:13px;line-height:1.6">丰源电力科技（涿州）有限公司<br>涿州市高官庄镇解家楼村村北</div>',
        })
        marker.on('click', () => infoWindow.open(map, marker.getPosition()))

        mapRef.current = map
      })
      .catch(() => {
        if (!disposed) setFailed(true)
      })

    return () => {
      disposed = true
      // 高德没有 dispose()，置空并移除 DOM 即可释放
      mapRef.current = null
    }
  }, [])

  if (!isAmapConfigured || failed) {
    return <MapFallback />
  }

  return <div className="amapCanvas" ref={holder} />
}

export default AmapView
